import fetchJsonp from 'fetch-jsonp';
import Cookie from './cookie';
import qs from 'qs';
import Client from './client';
import Tracker from './tracker';
const accountInfoUrl = '//promotion.aliyun.com/user/accountInfo.htm';

let USER_DATA = null;
export default class Account {
  static getLoginUrl(callback) {
    if (!callback) {
      callback = location.href;
    }
    return 'https://account.aliyun.com/login/login.htm?oauth_callback=' + encodeURIComponent(callback);
  }
  static async isLogin() {
    // const uid = Cookie.get('login_aliyunid');
    // if (uid) {
    //   return true;
    // } else {
    //   return false;
    // }
    return fetchJsonp(accountInfoUrl, { jsonpCallback: 'cback' })
      .then(res => res.json())
      .then(res => {
        if (res.code === 200) {
          USER_DATA = res.data;
          return true;
        }
        return false;
      })
      .catch(error => {
        throw new Error(error);
      });
  }
  static async getInfo() {
    const isLogin = await Account.isLogin();
    if (!isLogin) {
      return null;
    }
    const data = {};
    data.name = Cookie.get('login_aliyunid');
    data.uuid = Cookie.get('login_aliyunid_pk');
    data.avatar = `https://account.aliyun.com/common/header.htm?username=${data.name}`;

    const userData = USER_DATA
      ? USER_DATA
      : await fetchJsonp(accountInfoUrl, { jsonpCallback: 'cback' })
        .then(res => res.json())
        .then(res => {
          return res.data;
        });
    data.certified = userData.certified;
    return data;
  }
  static async certificate() {
    if (!Client.isMobile()) {
      const targetUrl = 'https://account.console.aliyun.com/?#/auth/home';
      const redirectUrl = Tracker.addSpm(targetUrl, 'body');
      return redirectUrl;
    }
    const params = {
      callbackUrl: encodeURIComponent(location.href),
    };
    return fetchJsonp(`https://page.aliyun.com/common/getApplyCertificationLink?${qs.stringify(params)}`)
      .then(res => res.json())
      .then(res => {
        return res.data;
      });
  }
}



// WEBPACK FOOTER //
// ./src/components/account.js